import React from "react";
import Style from "./Rating.module.scss";
import { LoyaltyInfoBlock } from "./components/LoyaltyInfoBlock";

export const LoyaltyInfoView = () => {
  return (
    <div className={Style.rating__info}>
      <div className={Style.rating__infoItem}>
        <LoyaltyInfoBlock number={1} title="Что такое Loyalty?">
          <p className={Style.rating__infoItemText}>
            Это программа лояльности Profi.Travel Loyalty. Баллы Loyalty – это
            поощрения, которое получают все участники за активность в
            онлайн-мероприятиях.
          </p>
        </LoyaltyInfoBlock>
      </div>
      <hr className={Style.rating__infoHr} />
      <div className={Style.rating__infoItem}>
        <LoyaltyInfoBlock number={2} title="Как получить баллы?">
          <div className={Style.rating__infoItemList}>
            <p className={Style.rating__infoItemText}>
              Баллы начисляют за активность:
            </p>
            <ul className={Style.rating__infoItemListUl}>
              <li>
                – регистрация:{" "}
                <span className={Style.rating__infoItemTextBold}>
                  +10 баллов
                </span>
                 
              </li>
              <li>
                – просмотр стендов экспонентов онлайн-выставки (один раз за
                онлайн-мероприятие):{" "}
                <span className={Style.rating__infoItemTextBold}>
                  +10 баллов
                </span>
                 
              </li>
              <li>
                – скачивание каталогов экспонентов онлайн-выставки (за каждый —
                каталог один раз за онлайн-мероприятие):{" "}
                <span className={Style.rating__infoItemTextBold}>
                  +15 баллов 
                </span>
              </li>
              <li>
                – просмотр более 50% каждого вебинара:{" "}
                <span className={Style.rating__infoItemTextBold}>
                  +100 баллов 
                </span>
              </li>
              <li>
                – просмотр каждого эфира в архиве:{" "}
                <span className={Style.rating__infoItemTextBold}>
                  +80 баллов 
                </span>
              </li>
              <li>
                – прохождение финального тестирования:{" "}
                <span className={Style.rating__infoItemTextBold}>
                  +1 000 баллов 
                </span>
                (+100 баллов за каждый правильный ответ, максимум за 10 вопросов
                тестирования — +1 000 баллов).
              </li>
            </ul>
          </div>
        </LoyaltyInfoBlock>
      </div>
      <hr className={Style.rating__infoHr} />
      <div className={Style.rating__infoItem}>
        <LoyaltyInfoBlock number={3} title="На что можно потратить баллы?">
          <div className={Style.rating__infoItemList2}>
            <p>
              Баллами Loyalty можно оплатить участие в платных проектах{" "}
              <a
                className="red-link"
                target="_blank"
                href="https://profi.travel/"
              >
                Profi.Travel.
              </a>
            </p>
            <p>
              Также баллы позволяют участвовать в{" "}
              <span className={Style.rating__infoItemTextBold}>
                розыгрыше призового фонда
              </span>{" "}
              онлайн-выставки OTM: Winter 25/26. Чтобы побороться за призы,
              нужно выйти в лидеры Рейтинга активности посетителей, то есть
              посмотреть все стенды, скачать все каталоги и смотреть все
              вебинары в прямом эфире. Розыгрыш призов проходит в последний день
              воркшопа, во время эфира закрытия.
            </p>
            <p>
              Участники Loyalty, которые активны во всех онлайн-мероприятиях
              Profi.Travel, становятся претендентами на участие в ежегодных
              фирменных фам-трипах Profi.Travel. Подробности на сайте{" "}
              <a
                target="_blank"
                href="https://profi.travel/loyalty"
                className={`${Style.rating__infoItemTextBold} blue-link`}
              >
                Loyalty.
              </a>
            </p>
          </div>
        </LoyaltyInfoBlock>
      </div>
      <hr className={Style.rating__infoHr} />
      <div className={Style.rating__infoItem}>
        <LoyaltyInfoBlock number={4} title="Кто участвует в Loyalty?">
          <p className={Style.rating__infoItemText}>
            В Loyalty могут участвовать только действующие турагенты
            (собственники или официально трудоустроенные). Мы можем запросить
            подтверждающие документы
          </p>
        </LoyaltyInfoBlock>
      </div>
    </div>
  );
};
